/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { SetWithManufacturer } from './SetWithManufacturer';
import {
    SetWithManufacturerFromJSON,
    SetWithManufacturerFromJSONTyped,
    SetWithManufacturerToJSON,
} from './SetWithManufacturer';

/**
 * 
 * @export
 * @interface SetPageable
 */
export interface SetPageable {
    /**
     * Array of sets with manufacturer info
     * @type {Array<SetWithManufacturer>}
     * @memberof SetPageable
     */
    items: Array<SetWithManufacturer>;
    /**
     * 
     * @type {Pageable}
     * @memberof SetPageable
     */
    meta: Pageable;
}

/**
 * Check if a given object implements the SetPageable interface.
 */
export function instanceOfSetPageable(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function SetPageableFromJSON(json: any): SetPageable {
    return SetPageableFromJSONTyped(json, false);
}

export function SetPageableFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPageable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SetWithManufacturerFromJSON)),
        'meta': PageableFromJSON(json['meta']),
    };
}

export function SetPageableToJSON(value?: SetPageable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(SetWithManufacturerToJSON)),
        'meta': PageableToJSON(value.meta),
    };
}

